import React from 'react'
import ContentLoading from './ContentLoading'

const RowLoading = ({ cells }) => {

  const tds = []

  for (let i = 0; i < cells; i++) {
    tds.push(<td key={i}><ContentLoading /></td>)
  }

  return (
    <>
      <tr>{tds}</tr>
      <tr>{tds}</tr>
      <tr>{tds}</tr>
      <tr>{tds}</tr>
      <tr>{tds}</tr>
    </>
  )
}

export default RowLoading;